import * as React from 'react';
import { SVGProps } from 'react';

const SvgPersonFilledOutlined = (props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" role="img" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 19a7 7 0 1 0 0-14 7 7 0 0 0 0 14Zm0 2a9 9 0 1 0 0-18 9 9 0 0 0 0 18Z"
      fill="currentColor"
    />
    <path d="M15 10a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" fill="currentColor" />
    <path d="M18 18c-2-5.5-10-5.5-12 0l6 1.5 6-1.5Z" fill="currentColor" />
  </svg>
);

export default SvgPersonFilledOutlined;
